import { initializeApp } from 'firebase/app';
import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  GoogleAuthProvider,
  indexedDBLocalPersistence,
  initializeAuth,
  type Auth
} from 'firebase/auth';
import firebaseConfig from './firebaseConfig.json';

export const firebaseEnabled = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId
);

let auth: Auth | null = null;

if (firebaseEnabled) {
  const app = initializeApp(firebaseConfig);
  // Durable persistence: keep the long-lived refresh token in indexedDB (falling
  // back to localStorage) so the session survives browser restarts. Firebase then
  // silently swaps the 1h ID token behind the scenes — the user stays logged in
  // indefinitely until they sign out or the refresh token is revoked, not just for
  // the lifetime of the tab.
  // initializeAuth (unlike getAuth) does NOT wire up a popup/redirect resolver by
  // default, so signInWithPopup would fail — pass it explicitly alongside the
  // durable persistence.
  auth = initializeAuth(app, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    popupRedirectResolver: browserPopupRedirectResolver
  });
}

export const firebaseAuth = auth;
export const googleProvider = new GoogleAuthProvider();
// Always show the account chooser so a signed-in browser can switch Google accounts.
googleProvider.setCustomParameters({ prompt: 'select_account' });
